import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=6f3d609d&"
import script from "./icon-button.vue?vue&type=script&lang=ts&"
export * from "./icon-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3d609d')) {
      api.createRecord('6f3d609d', component.options)
    } else {
      api.reload('6f3d609d', component.options)
    }
    module.hot.accept("./icon-button.vue?vue&type=template&id=6f3d609d&", function () {
      api.rerender('6f3d609d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/_icon-button/icon-button.vue"
export default component.exports